/*=========================================================================================
  File Name: module-notification-mutations.js
  Description: Notification Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import commonFunc from '@/common/commonFunction';
import { MSEnum } from '@/common/enumeration';
/**
 * state mặc định của module
 */
import defaultState from './module-notification-state';

export default {
    addNewNotification(state, data) {
        //Nếu không có dữ liệu/trường hợp xử lý thành công, thất bại tệp tin thì không hiển thị thông báo
        //Nếu là hóa đơn đầu vào upload bởi người dùng thì vẫn có thông báo (không return)
        if (!data ||
            (data.Type == 'FileHasProcessed' &&
                data.TypeReceive != MSEnum.TypeInvoiceReceive.Upload &&
                !data.IsOutbot) ||
            data.Type == 'FileFailedProcessed'
        ) {
            return;
        }

        //Thêm thông báo vào danh sách để hiển thị ở quả chuông
        data.__vKeyValue = commonFunc.generateUUID();
        state.NotificationList.unshift(data);
        state.countNew++;
        state.hasNewNotify = true;
    },
    updateStatusNewNotify(state, data) {
        state.hasNewNotify = data;
        if (data == false) {
            state.countNew = 0;
        }
    },
    updateNotificationList(state, data) {
        state.NotificationList = data;
    }
};